<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar bbm-avatar-contain">
            <img
              src="/assets/income.png"
              [alt]="'wallet' | transloco"
            >
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'Wallet Management' | transloco }}
            </span>

            <h2>
              {{ 'Wallet Management' | transloco }}
            </h2>

            <p>
              {{ 'Manage users wallet balance' | transloco }}
            </p>
          </div>

        </div>

        <div
          class="bbm-hero-counter"
          *ngIf="!contentReady"
        >
          <strong>
            {{ filteredData.length }}
          </strong>

          <span>
            {{ 'users' | transloco }}
          </span>
        </div>

      </div>

      <!-- NAVIGATION -->
      <div class="bbm-actions-grid bbm-hero-actions noPrint">

        <button
          type="button"
          routerLink="/promocode.mobile"
          class="bbm-action-btn bbm-action-warning"
        >
          <i
            class="fa-solid fa-ticket"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'Promo Code' | transloco }}
          </span>
        </button>

        <button
          type="button"
          routerLink="/notifications.mobile"
          class="bbm-action-btn bbm-action-primary"
        >
          <i
            class="fa-solid fa-bell"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'Notifications' | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- SEARCH -->
    <section class="bbm-form-ticket">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'Search users' | transloco }}
          </span>

          <h3>
            {{ 'Wallet Management' | transloco }}
          </h3>
        </div>
      </div>

      <div class="bbm-search-row">

        <div class="bbm-search-control">
          <i
            class="fa-solid fa-magnifying-glass"
            aria-hidden="true"
          ></i>

          <input
            type="text"
            class="bbm-control"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            [placeholder]="
              'Search by name, username or phone'
                | transloco
            "
          >
        </div>

        <button
          *ngIf="searchTerm"
          type="button"
          class="
            bbm-action-btn
            bbm-action-danger
            bbm-icon-action
          "
          (click)="clearSearch()"
          [title]="'Clear search' | transloco"
          [attr.aria-label]="'Clear search' | transloco"
        >
          <i
            class="fa-solid fa-xmark"
            aria-hidden="true"
          ></i>
        </button>

      </div>

    </section>

    <!-- NO DATA -->
    <div
      *ngIf="noData && !contentReady"
      class="bbm-empty-state"
    >
      <app-nodata></app-nodata>
    </div>

    <!-- USERS CARDS -->
    <section
      class="bbm-ticket-list"
      *ngIf="!noData"
    >
      <article
        class="bbm-ticket"
        *ngFor="
          let element of displayedData;
          trackBy: trackByUser
        "
      >

        <!-- USER TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar">
              {{ getUserInitial(element?.name) }}
            </div>

            <div class="bbm-copy">
              <span>
                {{ 'User wallet' | transloco }}
              </span>

              <h3>
                {{ element.name || '-' }}
              </h3>

              <p>
                <i
                  class="fa-solid fa-user"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ element.username || '-' }}
                </span>
              </p>
            </div>

          </div>

          <span class="bbm-value-pill bbm-value-success">
            {{ element.balance || 0 }}
            {{ 'egp' | transloco }}
          </span>

        </div>

        <!-- USER DETAILS -->
        <div class="bbm-details-grid">

          <div class="bbm-detail-chip">
            <i
              class="fa-solid fa-phone"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'phone' | transloco }}
            </span>

            <strong>
              {{ element.phone || '-' }}
            </strong>
          </div>

          <div class="bbm-detail-chip bbm-detail-success">
            <i
              class="fa-solid fa-wallet"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'Wallet balance' | transloco }}
            </span>

            <strong class="bbm-money-value">
              {{ element.balance || 0 }}
              {{ 'egp' | transloco }}
            </strong>
          </div>

        </div>

        <!-- ADD BALANCE -->
        <div class="bbm-actions-grid bbm-ticket-section">

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-success
              bbm-action-wide
            "
            (click)="addCredit(element)"
          >
            <i
              class="fa-solid fa-wallet"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'add balance' | transloco }}
            </span>
          </button>

        </div>

      </article>
    </section>

    <!-- LOADING MORE -->
    <div
      class="bbm-loader"
      *ngIf="isLoadingMore"
    >
      <span
        class="bbm-loader-spinner"
        aria-hidden="true"
      ></span>

      <span>
        {{ 'Loading more' | transloco }}
      </span>
    </div>

    <!-- END STATE -->
    <div
      class="bbm-end-state"
      *ngIf="
        !hasMore &&
        displayedData.length &&
        !contentReady
      "
    >
      {{ 'No more users' | transloco }}
    </div>

  </div>
</div>

<!-- ADD BALANCE POPUP -->
<div
  *ngIf="addBalancePopUp"
  class="bbm-modal-backdrop noPrint"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
  (click)="close()"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <div class="bbm-modal-handle"></div>

    <!-- MODAL HEADER -->
    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar bbm-avatar-contain">
          <img
            src="/assets/income.png"
            [alt]="'income' | transloco"
          >
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ 'Wallet Management' | transloco }}
          </span>

          <h3>
            {{ 'add balance' | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-icon-action
        "
        (click)="close()"
        [title]="'Close' | transloco"
        [attr.aria-label]="'Close' | transloco"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>
      </button>

    </div>

    <div class="bbm-modal-list">

      <!-- SELECTED USER -->
      <div
        class="bbm-profile-card bbm-wallet-profile-card"
        *ngIf="selectedUser"
      >
        <div class="bbm-profile-image bbm-wallet-profile-image">
          <div class="bbm-avatar">
            {{ getUserInitial(selectedUser?.name) }}
          </div>
        </div>

        <span class="bbm-eyebrow">
          {{ 'User wallet' | transloco }}
        </span>

        <h4>
          {{ selectedUser.name }}
        </h4>

        <span class="bbm-value-pill bbm-value-success">
          {{ selectedUser.balance || 0 }}
          {{ 'egp' | transloco }}
        </span>
      </div>

      <!-- BALANCE FORM -->
      <form class="bbm-form-grid">

        <div class="bbm-field bbm-field-wide">
          <label for="amount">
            {{ 'amount' | transloco }}
          </label>

          <input
            class="bbm-control"
            id="amount"
            type="number"
            min="0"
            [(ngModel)]="amount"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="'Enter amount' | transloco"
          >
        </div>

        <div class="bbm-field bbm-field-wide">
          <label for="note">
            {{ 'note' | transloco }}
          </label>

          <input
            class="bbm-control"
            id="note"
            type="text"
            [(ngModel)]="note"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="'Add a note' | transloco"
          >
        </div>

      </form>

    </div>

    <!-- MODAL ACTIONS -->
    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="onSubmit()"
        [disabled]="!amount || amount == 0 || isSubmitting"
      >
        <i
          *ngIf="!isSubmitting"
          class="fa-solid fa-check"
          aria-hidden="true"
        ></i>

        <span
          *ngIf="isSubmitting"
          class="bbm-loader-spinner"
          aria-hidden="true"
        ></span>

        <span>
          {{
            isSubmitting
              ? ('Saving...' | transloco)
              : ('Submit' | transloco)
          }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>

        <span>
          {{ 'Close' | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>
